/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

// import axios from "axios";
// import Modal from "react-responsive-modal";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class Poll extends Component {
  state = {};
  componentDidMount = () => {};

  _onClose = () => {
    //alert(0)
    const { setPollShow } = this.props;
    setPollShow(0);
  };
  _goPoll = () => {
    const { pollIdx, setPollShow } = this.props;

    //4411 4510
    //4511 4614
    //alert(pollIdx)
    //window.open()
    if (pollIdx >= 4411 && pollIdx <= 4510) {
      window.open(
        'https://aketo.aniplustv.com/poll/poll_offmall.asp?gubun=6',
        'poll',
        'width=650, height=700, scrollbars=yes'
      );
    } else if (pollIdx >= 4511 && pollIdx <= 4614) {
      window.open(
        'https://aketo.aniplustv.com/poll/poll_offmall.asp?gubun=7',
        'poll',
        'width=650, height=700, scrollbars=yes'
      );
    } else {
      alert('이미 참여하셨거나 앙케이트 대상 회원이 아닙니다.');
    }

    setPollShow(0);

    //https://aketo.aniplustv.com/poll/poll_offmall.asp?gubun=6  //기존회원
    //https://aketo.aniplustv.com/poll/poll_offmall.asp?gubun=7  //신규회원
  };
  render() {
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className={'detail_layer_pop'}>
          <div className="detail_view" style={{ overflowY: 'scroll' }}>
            <div
              className="detail_layer_close"
              style={{ cursor: 'pointer' }}
              onClick={this._onClose}
            >
              <img src={imgUrl + '/img/detail_img/close_1.png'} />
            </div>
            <div style={{ textAlign: 'center' }}>
              <img src={imgUrl + '/img/pop_up_01.png'} />
              <br />
              <img
                src={imgUrl + '/img/pop_up_02.jpg'}
                style={{ cursor: 'pointer' }}
                onClick={this._goPoll}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Poll));
